window.SubscriptionFunnel.StepExtraToy = {
  initialize() {
    if (
      SubscriptionFunnel.FunnelUtilities.promo_type === "FEXT" &&
      (Number(quizData.commitmentLength) === 3 ||
        Number(quizData.commitmentLength) === 6 ||
        Number(quizData.commitmentLength) === 12)
    ) {
      this.displayFreeExtraToyContent();
    } else if (
      SubscriptionFunnel.FunnelUtilities.promo_type === "FEXC" &&
      (Number(quizData.commitmentLength) === 3 ||
        Number(quizData.commitmentLength) === 6 ||
        Number(quizData.commitmentLength) === 12)
    ) {
      this.displayFreeExtraTreatContent();
    } else if (SubscriptionFunnel.FunnelUtilities.funnel_variant === "BNPL") {
      this.displayBNPLExtraToyContent();
    } else {
      this.displayDefaultExtraToyContent();
    }
  },

  displayFreeExtraToyContent() {
    this.hideDefaultDisplay();
    this.showPromoContainer(".fext-extra-toy-container");
    this.hidePromoContainer(".fexc-extra-treats-container");
    this.updateWelcomeGiftHeader();
    this.updateDogNameElements();
  },

  displayFreeExtraTreatContent() {
    this.hideDefaultDisplay();
    this.showPromoContainer(".fexc-extra-treats-container");
    this.hidePromoContainer(".fext-extra-toy-container");
    this.updateWelcomeGiftHeader();
    this.updateDogNameElements();
  },

  hideDefaultDisplay() {
    const defaultDisplay = document.querySelector(".bnpl-test-control");
    if (defaultDisplay) {
      defaultDisplay.classList.add("display-none");
    }
  },

  showPromoContainer(selector) {
    const container = document.querySelector(selector);
    if (container) {
      container.classList.remove("display-none");
    }
  },

  hidePromoContainer(selector) {
    const container = document.querySelector(selector);
    if (container) {
      container.classList.add("display-none");
    }
  },

  updateWelcomeGiftHeader() {
    const stepHeader = document.querySelector("#select-extra-toy-header");
    if (stepHeader) {
      stepHeader.innerHTML = `<span data-dog-name>Your pup</span>'s Welcome Gift Unlocked`;
    }
  },

  updateDogNameElements() {
    let dogName = quizData.dogName;

    document.querySelectorAll("[data-dog-name]").forEach((el) => {
      el.textContent = dogName || "your pup";
    });

    document.querySelectorAll("[data-dog-name-uppercase]").forEach((el) => {
      el.textContent = dogName.toUpperCase() || "your pup";
    });
  },

  displayBNPLExtraToyContent() {
    const defaultDisplay = document.querySelector(".bnpl-test-control");
    if (defaultDisplay) {
      defaultDisplay.classList.add("display-none");
    }

    const bnplDisplay = document.querySelector(".bnpl-test-v1");
    if (bnplDisplay) {
      bnplDisplay.classList.remove("display-none");
    }

    const stepHeader = document.querySelector("#select-extra-toy-header");
    if (stepHeader) {
      stepHeader.innerHTML = "Add an Extra Toy!";
    }
  },

  displayDefaultExtraToyContent() {
    const defaultDisplay = document.querySelector(".bnpl-test-control");
    if (defaultDisplay) {
      defaultDisplay.classList.remove("display-none");
    }

    const fextDisplay = document.querySelector(".fext-extra-toy-container");
    if (fextDisplay) {
      fextDisplay.classList.add("display-none");
    }

    const fexcDisplay = document.querySelector(".fexc-extra-treats-container");
    if (fexcDisplay) {
      fexcDisplay.classList.add("display-none");
    }

    const bnplDisplay = document.querySelector(".bnpl-test-v1");
    if (bnplDisplay) {
      bnplDisplay.classList.add("display-none");
    }

    const stepHeader = document.querySelector("#select-extra-toy-header");
    if (stepHeader) {
      stepHeader.innerHTML = "Get more dog joy!";
    }
  },

  updateXtcDisplay(isPrepaidActive, planDuration) {
    const xtcDescriptions = document.querySelectorAll(".xtc-description");
    const xtcMonthlyPrices = {
      full: document.querySelectorAll(".mobi-xtc-full-price"),
      discount: document.querySelectorAll(".mobi-xtc-discount-price"),
    };
    const xtcPrepaidPrices = {
      full: document.querySelectorAll(".upfrobi-xtc-full-price"),
      discount: document.querySelectorAll(".upfrobi-xtc-discount-price"),
    };
    const priceElements = {
      six: {
        xtcTotal: document.querySelector(".six_month_price_with_xtc"),
        prepaidXtcTotal: document.querySelector(
          ".six_month_price_with_prepaid_xtc"
        ),
      },
      twelve: {
        xtcTotal: document.querySelector(".twelve_month_price_with_xtc"),
        prepaidXtcTotal: document.querySelector(
          ".twelve_month_price_with_prepaid_xtc"
        ),
      },
    };

    const toggleDisplay = (elements, show) => {
      elements.forEach((el) => el.classList.toggle("display-none", !show));
    };

    // Toggle display for monthly and prepaid price elements
    if (!isPrepaidActive) {
      toggleDisplay(xtcMonthlyPrices.full, true);
      toggleDisplay(xtcMonthlyPrices.discount, true);
      toggleDisplay(xtcPrepaidPrices.full, false);
      toggleDisplay(xtcPrepaidPrices.discount, false);
    } else {
      toggleDisplay(xtcMonthlyPrices.full, false);
      toggleDisplay(xtcMonthlyPrices.discount, false);
      toggleDisplay(xtcPrepaidPrices.full, true);
      toggleDisplay(xtcPrepaidPrices.discount, true);
    }

    // Only update description text if there's no custom description set
    if (!SubscriptionFunnel.FunnelUtilities.hasCustomExtraToyDescription) {
      const descriptionText = isPrepaidActive
        ? SubscriptionFunnel.FunnelUtilities.extraToyDescriptionCopyPrepaid
        : SubscriptionFunnel.FunnelUtilities.extraToyDescriptionCopyMonthly;
      xtcDescriptions.forEach((el) => {
        el.classList.toggle("xtc-description-upfrobi", isPrepaidActive);
        el.innerHTML = descriptionText;
      });
    } else {
      // Just toggle the class for styling purposes, but don't change the innerHTML
      xtcDescriptions.forEach((el) => {
        el.classList.toggle("xtc-description-upfrobi", isPrepaidActive);
      });
    }

    // If prepaid is active, adjust price elements based on plan duration
    if (isPrepaidActive) {
      if (planDuration === "6") {
        priceElements.six.xtcTotal.classList.remove("display-none");
        priceElements.six.prepaidXtcTotal.classList.remove("display-none");
        priceElements.twelve.xtcTotal.classList.add("display-none");
        priceElements.twelve.prepaidXtcTotal.classList.add("display-none");
      } else if (planDuration === "12") {
        priceElements.twelve.xtcTotal.classList.remove("display-none");
        priceElements.twelve.prepaidXtcTotal.classList.remove("display-none");
        priceElements.six.xtcTotal.classList.add("display-none");
        priceElements.six.prepaidXtcTotal.classList.add("display-none");
      }
    }
  },

  applyPrepaidToggleXtcUpdates(event, selectedPlan) {
    // If the toggle is unchecked or the plan value is "1", it's a monthly plan.
    const isPrepaidActive = event.target.checked && selectedPlan?.value !== "1";
    const planDuration = selectedPlan?.value;
    this.updateXtcDisplay(isPrepaidActive, planDuration);
  },

  applyPlanClickXtcUpdates(event) {
    const planElement = event.target;
    const planElementId = planElement.id.toLowerCase();
    const prepaidToggle = document.querySelector("#prepayCheckbox");
    const prepaidToggleOn = prepaidToggle?.checked || false;
    const isPrepaid = planElementId.includes("month_prepaid");
    const isOneMoPlan = planElement.value === "1";
    const isPrepaidActive = (isPrepaid || prepaidToggleOn) && !isOneMoPlan;
    const planDuration = planElement.value;
    this.updateXtcDisplay(isPrepaidActive, planDuration);
  },
};
